import React from "react"
import { Button, Currencies, SFXS } from "@orbital/games-frontend-library"
import { Wrapper } from "../../styled"

export default function CashoutFooter({
  footerState,
  cashoutStake,
  handleCashout,
  currency,
}: any) {
  return (
    <Wrapper footerState={footerState === "cashout"} height="95px">
      <Button
        width="100%"
        textColor="#181731;"
        func={(b: boolean) => b && handleCashout()}
        SFX={SFXS.cashoutSFX}
      >
        <span>
          CASHOUT {Currencies[currency]}
          {""}
          {cashoutStake}
        </span>
      </Button>
    </Wrapper>
  )
}
